class CartFreeDeliveryRewardsPlusController {
    constructor(currencyFilter, settings) {
        this.currencyFilter = currencyFilter;
        this.settings = settings;
    }

    $onInit() {
        this.buildDisplayPrice(this.price);
        this.buildMessage();
    }

    $onChanges(change) {
        this.buildDisplayPrice(change.price.currentValue);
        this.buildMessage();
    }

    buildDisplayPrice(price) {
        if (price === undefined) { return; }
        this.formattedPrice = this.currencyFilter(price);
    }

    buildMessage() {
        this.messageParts = this.settings.everydayRewards.rewardsPlusFreeDeliveryMessage.split('{DeliveryFee}');
    }
}

const cartFreeDeliveryRewardsPlusComponentDefinition = {
    bindings: {
        price: '<',
    },
    controller: ['currencyFilter', 'Settings', CartFreeDeliveryRewardsPlusController],
    template: require('./cart-free-delivery-rewards-plus.component.html').trim(),
};

module.exports = {
    CartFreeDeliveryRewardsPlusController,
    cartFreeDeliveryRewardsPlusComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/shop/cart/cart-free-delivery-rewards-plus.component.js